import {request} from './../request.js'
import AppConfig from '../../../config/AppConfig.js'


// 翻译接口调用，中文翻译到英语
/**
 * @param {Object} id 粉丝id或者群id
 * @param {Object} type 类型：fans/cluster
 * @param {Object} callback
 */
export function webZhToEn(param,callback){
	request({
			method: 'post',
			url: 'Fanyi/zhToEn',
			data: param
	}).then((response)=>{
		callback(response.data)
	}).catch((error)=>{
		console.error(error)
		callback(false)
	})
}


// 翻译接口调用，英语翻译到中文
export function webEnToZh(param,callback){
	request({
			method: 'post',
			url: 'Fanyi/enToZh',
			data: param
	}).then((response)=>{
		callback(response.data)
	}).catch((error)=>{
		console.error(error)
		callback(false)
	})
}